import * as actionTypes from '../actions/actionTypes';
import updateState from '../../utility'

const intialState = {
  loading: false,
  token : null,
  error: null,
  userId: null,
  redirectTo: '/'
}

const reducer = (state = intialState, action) =>{
  switch (action.type) {
   
    case actionTypes.SIGN_IN_START: 
      return updateState(state, {error: null, loading: true});

    case actionTypes.SIGN_IN_SUCCESS:
       return updateState(state, {token: action.idToken ,error: null, userId: action.userId, loading: false});

    case actionTypes.SIGN_IN_FAIL:
      return updateState(state, {error: action.error, loading: false});

    case actionTypes.AUTH_LOGOUT:
      return updateState(state, {token: null, userId: null});

    case actionTypes.AUTH_REDIRECT:
      return updateState(state, {redirectTo: action.path});

    default:
      return state;
  }
}

export default reducer;



// WEBPACK FOOTER //
// ./src/store/reducer/auth.js